<template>
  <div class="animated">
    <h3>
      Results
      <b-button class="text-white float-right ml-1" variant="success"
        ><i class="fa fa-check-square" /> Approve All</b-button
      >
    </h3>

    <AnalyteResultServerTable
      v-if="analyte_result_collection"
      :collection="analyte_result_collection"
    />
  </div>
</template>

<script>
import AnalyteTable from '@/components/lab/analyte/AnalyteTable'
import AnalyteResultServerTable from "@/components/lab/analyte/AnalyteResultServerTable"
import AnalyteResultCollection from '@/collections/lab/AnalyteResultCollection';
import { getCollection } from '@/shared/fetch-utils'

export default {
  name: "SampleResultTable",
  components: {
    AnalyteTable,
    AnalyteResultServerTable
  },
  props: {
    trigger_approval_all: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sample_id: this.$route.params.sample_id || null,
      analyte_result_collection: null,
      analyte_result_status: null
    };
  },
  async created() {
    this.analyte_result_status = await getCollection({
      collection_type: "analyte_result_status",
      filters: [
        {
          logic: "filterEquals",
          field: "status",
          value: "Approved"
        }
      ]
    })

    const collection = new AnalyteResultCollection()
    const filter = collection.getFilter()
    filter.filterEquals('sample_id', this.sample_id)

    if (this.analyte_result_status.models.length > 0) {
      filter.filterEquals('currentAnalyteResultStatusLog.analyte_result_status_id', this.analyte_result_status.models[0].id)
    }

    filter.cacheStaticFilters()
    this.analyte_result_collection = collection
  }
};
</script>
